import Backbone from 'backbone';
import _ from 'underscore';

function OptionalDependency(context, options) {
    this.context = context;
    this.options = options;
    this.module = null;
}

OptionalDependency.Events = {
    Fetched: 'FETCHED'
};

OptionalDependency.prototype.load = function() {
    var _this = this;
    if (this.shouldLoad()) {
        this.options.url
            .then(({ default: module }) => {
                _this.options.module = module;
                _this.trigger(OptionalDependency.Events.Fetched, module);
            })
            .catch((error) => {
                _this.trigger(OptionalDependency.Events.Fetched);
            });
    }
};

OptionalDependency.prototype.shouldLoad = function() {
    return this.options.truthTest.call(this.context, this.context);
};

_.extend(OptionalDependency.prototype, Backbone.Events);

export default OptionalDependency;
